<template>
  <div class="modal__inner-1" role="dialog">
    <div class="modal__inner-2">
      <button class="modal__close-button button not-tabbable" @click="config.reject()" v-title="'Close modal'">
        <icon-close></icon-close>
      </button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('modal', [
      'config',
    ]),
  },
};
</script>

<style lang="scss">
@import '../../../styles/variables.scss';

.modal__close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  color: rgba(0, 0, 0, 0.5);
  width: 28px;
  height: 28px;
  padding: 0;
  z-index: 10;
  background: transparent;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: visible;
  line-height: 1;

  .app--dark & {
    color: rgba(255, 255, 255, 0.5);
  }

  .icon {
    width: 18px;
    height: 18px;
    display: block;
    margin: 0;
    flex-shrink: 0;
  }

  &:active,
  &:focus,
  &:hover {
    color: rgba(0, 0, 0, 0.75);
    background: rgba(0, 0, 0, 0.05);

    .app--dark & {
      color: rgba(255, 255, 255, 0.75);
      background: rgba(255, 255, 255, 0.05);
    }
  }
}
</style>
